import React, { FC} from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
} from '@mui/material';
import {
  Timeline,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
} from '@mui/lab';
import { 
  ImgBox,
  Typography700,
 } from 'views/rebranded-module/common/components';
import  StyledBox  from 'views/rebranded-module/membership-module/MembershipLandingViewV2/components/HowItWorksSection/HowItWorksSection.styles';
import ScrollTo from 'lib/utils/ScrollTo';
import { useContent } from 'views/rebranded-module/common/context/useContent';

const HowItWorksSection: FC<any> = () => {
const content = useContent('MembershipLandingPage');
 const handleScrollToPlansComparison = () => {
  ScrollTo('plans-comparison-section', -60);
};

  return (
    <StyledBox>
       <Box className="HIWSContantContainer">
            <Container maxWidth="xl">
                <Typography700 component="h2" variant='h2' mb={3}>
                    {content.howItWorksSectionTitle}
                </Typography700>
                <Typography component="p" variant="body1" mb={4}>
                    {content.howItWorksSectionDescription}
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={handleScrollToPlansComparison}
                  >
                    {content.joinClubBtn}
                 </Button>
                <Timeline className="HIWSTimeLine">
                  {/* empty TimelineItem without Connector and content to to align with the styling in the Figma design */}
                  <TimelineItem className="HIWSTimeIItem">
                    <TimelineSeparator>
                      <TimelineConnector className="HIWSTimelineConnector HIWSEmptyConnector" />
                    </TimelineSeparator>
                  </TimelineItem>
                  {content.howItWorksSteps.map((step) => (
                    <TimelineItem className="HIWSTimeIItem" key={step.step}>
                      <TimelineSeparator>
                        <TimelineDot className="HIWSTimelineDot" />
                        <TimelineConnector className="HIWSTimelineConnector" />
                      </TimelineSeparator>
                      <TimelineContent className="HIWSTimelineContent">
                        <Typography700 component="p" variant="overline1" mb={2}>
                            {step.step}
                        </Typography700>
                         <Typography700 component="p" variant="h4" mb={2}>
                            {step.title}
                        </Typography700>
                        <Typography component="p" variant="body1">
                            {step.description}
                        </Typography>
                      </TimelineContent>
                    </TimelineItem>
                  ))}
                 </Timeline>
            </Container>
         </Box>
       <Box className="HIWSBackground">
        <ImgBox
          image={{
            src: '/imgs/Rebranding/petterns/map.jpg',
            alt: 'map background',
          }}
          width="100%"
          height="100%"
        />
        <Box className="HIWSBGOverlay" />
      </Box>
    </StyledBox>
  );
};

export { HowItWorksSection };